"use client";

import { c as _c } from "react/compiler-runtime";
import { LandvestHandoffLink } from "@/components/layout/LandvestHandoffLink";
import { cn } from "@/lib/utils";
interface MegaMenuItemProps {
  label: string;
  description?: string;
  href: string;
  onClick?: () => void;
  /** Dropdown entries (Leistungen, Für Flächeneigentümer): padded rows with a hover tint. */
  compact?: boolean;
  /** A column of plain links (the Wissen columns): label only, set by the section. */
  plain?: boolean;
}

/** One menu entry: title with a line of description, or a plain link in a plain-link column. */
export function MegaMenuItem(t0) {
  const $ = _c(19);
  const {
    label,
    description,
    href,
    onClick,
    compact: t1,
    plain: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const plain = t2 === undefined ? false : t2;
  if (plain || !description) {
    let t3;
    if ($[0] !== href || $[1] !== label || $[2] !== onClick) {
      t3 = <li><LandvestHandoffLink href={href} onClick={onClick} className="text-[15px] font-semibold text-primary hover:text-secondary transition-colors" role="menuitem">{label}</LandvestHandoffLink></li>;
      $[0] = href;
      $[1] = label;
      $[2] = onClick;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t3 = compact && "px-3.5 py-3 rounded-xl hover:bg-primary/5 transition-colors";
  let t4;
  if ($[4] !== t3) {
    t4 = cn("group flex flex-col gap-[3px]", t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = compact ? "text-base" : "text-[17px]";
  let t6;
  if ($[6] !== t5) {
    t6 = cn("font-bold text-primary group-hover:text-secondary transition-colors", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== label || $[9] !== t6) {
    t7 = <span className={t6}>{label}</span>;
    $[8] = label;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== description) {
    t8 = <span className="text-[13px] leading-[1.45] text-on-surface-variant">{description}</span>;
    $[11] = description;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== href || $[14] !== onClick || $[15] !== t4 || $[16] !== t7 || $[17] !== t8) {
    t9 = <li><LandvestHandoffLink href={href} onClick={onClick} className={t4} role="menuitem">{t7}{t8}</LandvestHandoffLink></li>;
    $[13] = href;
    $[14] = onClick;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}